import TablePageTree from './tablePageTree.vue';

export default TablePageTree;
